import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { Provider } from 'react-redux';
import { store } from 'store';
import App from './App';

const fnolServiceWindowElement = document.getElementById('fnolServiceWindow');

const initReactApp = () => {
	if (fnolServiceWindowElement) {
		console.info('React app not mounted: fnolServiceWindow is active.');
		return;
	}

	const app = ReactDOM.createRoot(document.getElementById('app') as HTMLElement);

	app.render(
		<Provider store={store}>
			<BrowserRouter>
				<App />
			</BrowserRouter>
		</Provider>
	);
};

initReactApp();
